import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	background-color: ${tokens.color_white};
	padding: 0 20px 20px;
`;
